(function () {
  'use strict';

  // Capture sticky-bar button clicks before the inline script fires mainBtn.click()
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp__sticky-btn');
    if (!btn) return;
    e.stopImmediatePropagation();

    var form = document.querySelector('form[action*="cart/add"]');
    if (!form) return;
    if (form.reportValidity && !form.reportValidity()) return;

    var fd = new FormData(form);
    // Ensure the correct variant ID is set (payment_button may inject its own id field)
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) fd.set('id', idInput.value);

    var addBtn = form.querySelector('[name="add"]');
    setLoading(btn, true);
    if (addBtn) setLoading(addBtn, true);

    doAjaxAdd(fd, btn, function () {
      setLoading(btn, false);
      if (addBtn) setLoading(addBtn, false);
    }, function () {
      setLoading(btn, false);
      if (addBtn) { setLoading(addBtn, false); addBtn.click(); }
    });
  }, true);

  // Intercept product form submit events to do AJAX + animation instead
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('cart/add') === -1) return;
    // Let "Buy Now" (checkout) submit pass through normally
    if (e.submitter && e.submitter.name === 'checkout') return;

    e.preventDefault();

    var fd = new FormData(form);
    // Ensure the correct variant ID is set (payment_button may inject its own id field)
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) fd.set('id', idInput.value);

    var src = document.querySelector('.pslider__img[data-pslider-img]')
           || form.querySelector('[name="add"]');
    var addBtn = form.querySelector('[name="add"]');
    if (addBtn) setLoading(addBtn, true);

    doAjaxAdd(fd, src, function () {
      if (addBtn) setLoading(addBtn, false);
    }, function () {
      if (addBtn) setLoading(addBtn, false);
      form.submit();
    });
  }, true);

  function doAjaxAdd(fd, animSrc, onDone, onError) {
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        onDone();
        flyToCart(animSrc);
        updateBadge(cart.item_count);
      })
      .catch(onError);
  }

  function setLoading(el, state) {
    el.disabled = state;
    el.classList.toggle('is-loading', state);
  }

  function flyToCart(sourceEl) {
    if (!sourceEl) return;
    // Prefer the visible sticky bar cart link, fall back to header icon
    var stickyBar = document.querySelector('.pdp__sticky.is-visible');
    var targetEl = (stickyBar && stickyBar.querySelector('.pdp__sticky-cart-link'))
                || document.querySelector('.hdr__count')
                || document.querySelector('.hdr__icon[href*="cart"]');
    if (!targetEl) return;

    var from = sourceEl.getBoundingClientRect();
    var to   = targetEl.getBoundingClientRect();

    var orb = document.createElement('div');
    orb.className = 'atc-orb';
    if (sourceEl.tagName === 'IMG') {
      orb.style.backgroundImage = 'url(' + (sourceEl.currentSrc || sourceEl.src) + ')';
    }
    orb.style.left = (from.left + from.width  / 2) + 'px';
    orb.style.top  = (from.top  + from.height / 2) + 'px';
    document.body.appendChild(orb);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        orb.classList.add('atc-orb--fly');
        orb.style.left = (to.left + to.width  / 2) + 'px';
        orb.style.top  = (to.top  + to.height / 2) + 'px';
        orb.addEventListener('transitionend', function () { orb.remove(); }, { once: true });
      });
    });
  }

  function updateBadge(count) {
    // Update header badge
    var badge = document.querySelector('.hdr__count');
    var cartIcon = document.querySelector('.hdr__icon[href*="cart"]');
    if (!badge && count > 0 && cartIcon) {
      badge = document.createElement('span');
      badge.className = 'hdr__count';
      cartIcon.appendChild(badge);
    }
    if (badge) {
      badge.textContent = count;
      badge.classList.remove('hdr__count--bump');
      void badge.offsetWidth;
      badge.classList.add('hdr__count--bump');
    }

    // Update all sticky-bar cart count badges
    document.querySelectorAll('.js-atc-count').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
        el.classList.remove('hdr__count--bump');
        void el.offsetWidth;
        el.classList.add('hdr__count--bump');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }
})();
